import React, { useEffect, useState } from "react";
import axios from "axios";
import { Header, Footer, Page } from "@/components/Shell";
import { API } from "@/lib/brand";

export const HUMAN_LABELS = {
  LEGAL_BUSINESS_NAME: "Dénomination sociale légale",
  BUSINESS_ADDRESS: "Adresse d'affaires",
  BUSINESS_REGISTRATION_NUMBER: "Numéro d'entreprise (NEQ ou équivalent)",
  TAX_REGISTRATION_INFORMATION: "Renseignements de taxes applicables (TPS/TVQ ou équivalent)",
  PRIVACY_OFFICER_NAME_OR_TITLE: "Responsable de la protection des renseignements personnels",
  PRIVACY_EMAIL: "Courriel dédié à la vie privée",
  REPORT_DELIVERY_TIME: "Délai réel de livraison du rapport",
  REPORT_ACCESS_DURATION: "Durée d'accès au rapport en ligne",
  PERSONAL_DATA_RETENTION_PERIOD: "Durée de conservation des renseignements personnels",
  REPORT_RETENTION_PERIOD: "Durée de conservation des rapports générés",
  ACCOUNT_RETENTION_PERIOD: "Durée de conservation des comptes",
  ANALYTICS_RETENTION_PERIOD: "Durée de conservation des données d'analytique",
  REFUND_POLICY_EFFECTIVE_DATE: "Date d'entrée en vigueur de la politique de remboursement",
  PRIVACY_POLICY_EFFECTIVE_DATE: "Date d'entrée en vigueur de la politique de confidentialité",
  TERMS_EFFECTIVE_DATE: "Date d'entrée en vigueur des conditions",
};

export function useLegalInfo() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/legal-info`);
        setInfo(data);
      } catch {
        setInfo({ missing_fields: [], providers_used: {} });
      }
    })();
  }, []);
  return info;
}

export function Val({ info, k, fallback = "à confirmer" }) {
  const v = info?.[k];
  if (v && String(v).trim().length > 0) return <>{v}</>;
  return <em className="text-bronze-dark" data-testid={`val-missing-${k}`}>[{fallback}]</em>;
}

export function MissingFieldsBlock({ info }) {
  if (!info) return null;
  const missing = info.missing_fields || [];
  if (missing.length === 0) return null;
  return (
    <div className="legal-todo" data-testid="missing-fields">
      <div className="overline mb-2">Informations obligatoires à confirmer avant publication</div>
      <p className="text-[13px] leading-relaxed">
        Les éléments suivants ne sont pas encore renseignés dans l'environnement de la plateforme.
        Aucune valeur n'a été inventée. Ces informations doivent être confirmées avant toute publication publique.
      </p>
      <ul>
        {missing.map((k) => (<li key={k}>· {HUMAN_LABELS[k] || k}</li>))}
      </ul>
    </div>
  );
}

export default function LegalPage({ title, overline, children }) {
  return (
    <Page tone="ivory">
      <Header variant="ivory" />
      <section className="max-w-3xl mx-auto px-6 md:px-10 pt-20 pb-24" data-testid="legal-page">
        <div className="overline mb-4">{overline}</div>
        <h1 className="font-display text-[38px] md:text-[48px] leading-tight text-ink">{title}</h1>
        <div className="architect-line my-10 max-w-md" />
        <div className="legal-prose">
          {children}
        </div>
      </section>
      <Footer />
    </Page>
  );
}
